import { render, staticRenderFns } from "./service_ruzhu.vue?vue&type=template&id=2e53760d&scoped=true"
import script from "./service_ruzhu.vue?vue&type=script&lang=js"
export * from "./service_ruzhu.vue?vue&type=script&lang=js"
import style0 from "./service_ruzhu.vue?vue&type=style&index=0&id=2e53760d&prod&lang=scss"
import style1 from "./service_ruzhu.vue?vue&type=style&index=1&id=2e53760d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53760d",
  null
  
)

export default component.exports